// A job's visit drawn by the board's own VisitBlock, compact (one line: the window and who), so a visit
// looks the same on the job page as on the board: JobPage's visitBlock slot and VisitRow's block. Its
// state is the drawing (DESIGN.md §2); a booked visit with no one on it is the board's "No one yet". It
// isn't a control here (the row's button opens the visit), so it's out of the tab order; its label
// still says it all.
import { VisitBlock, type VisitState } from '../components/VisitBlock/VisitBlock.tsx';
import type { Pen } from '../components/pen.ts';
import type { JobVisit } from './job-view.ts';

const STATE: Record<JobVisit['drawn'], VisitState> = {
  booked: 'booked',
  paused: 'paused',
  working: 'working',
  done: 'done',
  cancelled: 'cancelled',
};

export function JobVisitBlock({
  v,
}: {
  v: Pick<JobVisit, 'n' | 'window' | 'techs' | 'pens' | 'drawn' | 'word'>;
}) {
  const nobody = v.drawn === 'booked' && !v.pens.length;
  const lead = v.pens[0];
  return (
    <VisitBlock
      state={nobody ? 'unassigned' : STATE[v.drawn]}
      pen={lead && lead >= 1 && lead <= 8 ? (lead as Pen) : null}
      time={v.window}
      timeShort={v.window.split(/[–-]/)[0]!.trim()}
      customer={v.techs}
      job={`Visit ${v.n}`}
      density="compact"
      label={`Visit ${v.n}, ${v.window}, ${v.techs}: ${v.word}`}
      tabIndex={-1}
    />
  );
}
